import { isServer } from '@app/utils';

/**
 * Isomorphically load initial recoil values from either the window or our req logic.
 *
 * @param req
 */
const getInitialRecoilData = (req) => {
  let initialRecoilState = {};
  if (isServer && req?.appContext?.appConfig?.initialRecoilState) {
    initialRecoilState = req.appContext.appConfig?.initialRecoilState;
  } else if (!isServer && window?.initialRecoilState) {
    initialRecoilState = window?.initialRecoilState;
  }

  return initialRecoilState;
};

export default getInitialRecoilData;
